import {
  saLimitedReleaseDetailConstants,
  createSaLimitedReleaseDetailConstants,
  editSaLimitedReleaseDetailConstants,
  activateSaLimitedReleaseDetailConstants,
  deactivateSaLimitedReleaseDetailConstants,
  deleteSaLimitedReleaseDetailConstants,
} from "../_redux-constants";
import { saLimitedReleasesDetailService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getSaLimitedReleaseDetail(queryParams) {
  function getSaLimitedReleaseDetailLoad() {
    return {
      type: saLimitedReleaseDetailConstants.SA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function getSaLimitedReleaseDetailSuccess(data) {
    return {
      type: saLimitedReleaseDetailConstants.SA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function getSaLimitedReleaseDetailFailure(error) {
    return {
      type: saLimitedReleaseDetailConstants.SA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getSaLimitedReleaseDetailLoad());
    return saLimitedReleasesDetailService
      .getSaLimitedReleaseDetail(queryParams)
      .then(
        (data) => {
          dispatch(getSaLimitedReleaseDetailSuccess(data));
        },
        (error) => {
          dispatch(getSaLimitedReleaseDetailFailure(error?.toString()));
        }
      );
  };
}

function createSaLimitedReleaseDetail(requestBody, queryParams) {
  function createSaLimitedReleaseDetailLoad() {
    return {
      type: createSaLimitedReleaseDetailConstants.CREATE_SA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function createSaLimitedReleaseDetailSuccess(data) {
    return {
      type: createSaLimitedReleaseDetailConstants.CREATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function createSaLimitedReleaseDetailFailure(error) {
    return {
      type: createSaLimitedReleaseDetailConstants.CREATE_SA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createSaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      saLimitedReleasesDetailService
        .createSaLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(createSaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(createSaLimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function editSaLimitedReleaseDetail(requestBody, queryParams) {
  function editSaLimitedReleaseDetailLoad() {
    return {
      type: editSaLimitedReleaseDetailConstants.EDIT_SA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function editSaLimitedReleaseDetailSuccess(data) {
    return {
      type: editSaLimitedReleaseDetailConstants.EDIT_SA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function editSaLimitedReleaseDetailFailure(error) {
    return {
      type: editSaLimitedReleaseDetailConstants.EDIT_SA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editSaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      saLimitedReleasesDetailService
        .editSaLimitedReleaseDetail(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editSaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editSaLimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function activateSaLimitedReleaseDetail(queryParams) {
  function activateSaLimitedReleaseDetailLoad() {
    return {
      type: activateSaLimitedReleaseDetailConstants.ACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function activateSaLimitedReleaseDetailSuccess(data) {
    return {
      type: activateSaLimitedReleaseDetailConstants.ACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function activateSaLimitedReleaseDetailFailure(error) {
    return {
      type: activateSaLimitedReleaseDetailConstants.ACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(activateSaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      saLimitedReleasesDetailService
        .activateSaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(activateSaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(activateSaLimitedReleaseDetailFailure(error?.toString()));
            reject(error);
          }
        );
    });
  };
}

function deactivateSaLimitedReleaseDetail(queryParams) {
  function deactivateSaLimitedReleaseDetailLoad() {
    return {
      type: deactivateSaLimitedReleaseDetailConstants.DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deactivateSaLimitedReleaseDetailSuccess(data) {
    return {
      type: deactivateSaLimitedReleaseDetailConstants.DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deactivateSaLimitedReleaseDetailFailure(error) {
    return {
      type: deactivateSaLimitedReleaseDetailConstants.DEACTIVATE_SA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deactivateSaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      saLimitedReleasesDetailService
        .deactivateSaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deactivateSaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(
              deactivateSaLimitedReleaseDetailFailure(error?.toString())
            );
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function deleteSaLimitedReleaseDetail(queryParams) {
  function deleteSaLimitedReleaseDetailLoad() {
    return {
      type: deleteSaLimitedReleaseDetailConstants.DELETE_SA_LIMITED_RELEASE_DETAIL_LOADING,
    };
  }
  function deleteSaLimitedReleaseDetailSuccess(data) {
    return {
      type: deleteSaLimitedReleaseDetailConstants.DELETE_SA_LIMITED_RELEASE_DETAIL_SUCCESS,
      data,
    };
  }
  function deleteSaLimitedReleaseDetailFailure(error) {
    return {
      type: deleteSaLimitedReleaseDetailConstants.DELETE_SA_LIMITED_RELEASE_DETAIL_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteSaLimitedReleaseDetailLoad());
    return new Promise((resolve, reject) => {
      saLimitedReleasesDetailService
        .deleteSaLimitedReleaseDetail(queryParams)
        .then(
          (data) => {
            dispatch(deleteSaLimitedReleaseDetailSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(deleteSaLimitedReleaseDetailFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

export const saLimitedReleasesDetailActions = {
  getSaLimitedReleaseDetail,
  createSaLimitedReleaseDetail,
  editSaLimitedReleaseDetail,
  activateSaLimitedReleaseDetail,
  deactivateSaLimitedReleaseDetail,
  deleteSaLimitedReleaseDetail,
};
